import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  
  file: {
    height: '100%',
    width: '100%'
  }
})

export default useStyles
